import { useLevels } from "@dyl/systems/LevelsManager";
import { useTitle } from "@dyl/systems/TitleManager";
import { useAutomarkerTargetTemplates } from "@dyl/systems/AmttManager";
import React, { useMemo } from "react";
import GenericDeleteAction from "@dyl/components/GenericDeleteAction";
import { deleteAutomarkerTargetTemplate } from "@dyl/apiClients/backendApi";
import DataGridDyl from "@dyl/components/DataGridDyl";
import ScreenActions from "@dyl/components/ScreenActions";
import LinkButton from "@dyl/components/LinkButton";
import { Fab } from "@mui/material";
import { Add } from "@mui/icons-material";
import makeStyles from "@mui/styles/makeStyles";
import { property } from "lodash";


const getId = property('target_template_id');

const useStyles = makeStyles(theme => ({
    deleteButton: {
        color: theme.palette.error.main,
    },
}));

export default function AutoMarkerTargetTemplatesList() {
    const classes = useStyles();
    const { globalLevel } = useLevels();

    const getUrl = ({ row }) => `/${globalLevel.label}/amtt/${row.target_template_id}`;

    useTitle('Automarker Target Templates');

    const { templates, templatesStatus, refreshTemplates } = useAutomarkerTargetTemplates();

    const columns = useMemo(
        /** @returns {import('@mui/x-data-grid').GridColDef[]} */
        () => [
            { headerName: 'Name', field: 'name', flex: 3 },
            { headerName: 'Actions', field: 'ADMIN_DELETE', flex: 1,
                renderCell({ row }) {
                    return (<GenericDeleteAction
                        data={row}
                        promptTexts={
                            {
                                dialogTitle: () => 'Delete Test Component?',
                                dialogText: (data) => [
                                    `Are you sure you want to delete template "${data.name}"?`,
                                    `Tasks which have imported this template will *not* be affected.`
                                ],
                                ongoingNotification: (data) => `Deleting "${data.name}"...`,
                                successNotification: (data, response) => `Deleted "${data.name}".`,
                                failureNotification: (data, response) => `Failed to delete "${data.name}".`,
                                errorNotification: (data) => `Failed to delete "${data.name}".`
                            }
                        }
                        deleteAction={(data) => deleteAutomarkerTargetTemplate(data.target_template_id)}
                        onDelete={refreshTemplates}
                        responseSuccessPredicate={(response) => true}
                    />)
                }
            },
        ],
        [classes]
    );

    return (
        <>
            <DataGridDyl
                rows={templates}
                getRowId={getId}
                loading={templatesStatus === 'loading'}
                columns={columns}
                variant='links'
                getRowUrl={getUrl}
                searchField='name'
            />

            <ScreenActions>
                <LinkButton component={Fab}
                            color='primary'
                            size='large'
                            variant='extended'
                            to={`/${globalLevel.label}/amtt/new`}
                >
                    <Add />&nbsp;New
                </LinkButton>
            </ScreenActions>
        </>
    );
}